var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"filters-mobile-results-btn",attrs:{"href":"javascript:void(0);","type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.showFilter.apply(null, arguments)}}},[_vm._v("\n  Leita í söluskrá\n  "),_c('span',[_vm._v(_vm._s(_vm.resultCount))]),_c('leita',{staticClass:"leita"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }